import {NgModule} from '@angular/core';
import {SharedModule} from '../../../core/shared.module';
import {CustomerNavigationComponent} from './customer-navigation.component';
import {UIRouterModule} from '@uirouter/angular';
import {CustomerRestoreButtonReactComponent} from '../restore/customer-restore-button-react.component';

@NgModule({
  imports: [
    UIRouterModule.forChild(),
    SharedModule,
    CustomerRestoreButtonReactComponent,
  ],
  declarations: [
    CustomerNavigationComponent,
  ],
  exports: [
    CustomerNavigationComponent,
  ]
})
export class CustomerNavigationModule {
}
